import { Component, OnInit, ViewChild } from '@angular/core';
import { GoogleMap, InfoWindow, LatLngBounds } from '@agm/core/services/google-maps-types';
import { ApiService } from '../../../shared/services/api.service';
import { JhiLanguageService } from 'ng-jhipster';
import { AgmMap } from '@agm/core';
import { MarketdateBoothGeoData } from '../../../entities/marketdate-booth-geo-data.model';
import * as moment from 'moment';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

declare var google: any;

interface CustomMarker {
  marketdateBoothGeoData: MarketdateBoothGeoData;
  marker: any;
  infoWindow: InfoWindow;
}

@Component({
  selector: 'app-geographical-data',
  templateUrl: './geographical-data.component.html',
  styles: []
})

export class GeographicalDataComponent implements OnInit {

  @ViewChild('agmMap') agmMap: AgmMap;
  @ViewChild('marketDaySelectionModal') marketDaySelectionModal;
  loadingIndicator = true;
  map: GoogleMap;
  marketdateBoothGeoData: Array<MarketdateBoothGeoData>;
  marketplaceMarkers: Array<CustomMarker>;
  merchantMarkers: Array<CustomMarker>;
  marketplaceDays = new Map();
  availableMarketdates = new Set();

  private modalRef: any = null;
  public selectedMarket: Array<MarketdateBoothGeoData>;
  public selectedMarketDay: MarketdateBoothGeoData;
  public selectedDate: string;

  constructor(private jhiLanguageService: JhiLanguageService,
              private apiService: ApiService, private modalService: NgbModal) {
    this.jhiLanguageService.setLocations(['evaluation']);
  }

  ngOnInit() {
    this.findMarketdateBoothGeoData();
  }

  findMarketdateBoothGeoData() {
    this.loadingIndicator = true;
    this.apiService.find<MarketdateBoothGeoData>(MarketdateBoothGeoData, ['backoffice', 'marketdate-booth-geo-data'].join('/'))
      .subscribe((marketdateBoothGeoData: Array<MarketdateBoothGeoData>) => {
        marketdateBoothGeoData.forEach(
          (entry) => {
            if (this.marketplaceDays.has(entry.mplaceId)) {
              const existing = this.marketplaceDays.get(entry.mplaceId);
              existing.push(entry);
              this.marketplaceDays.set(entry.mplaceId, existing);
            } else {
              this.marketplaceDays.set(entry.mplaceId, [entry]);
            }
          }
        );
        this.loadingIndicator = false;
        this.marketdateBoothGeoData = marketdateBoothGeoData;
      });
  }

  getMarketdateBoothGeoData(marketdayId: number, reset = true): Promise<Array<MarketdateBoothGeoData>> {
    this.availableMarketdates = new Set();
    if (reset) {
      this.selectedDate = null;
      console.log('Reset selectedDate to null.');
    }
    return new Promise<Array<MarketdateBoothGeoData>>((resolve, reject) => {
      this.apiService.find<MarketdateBoothGeoData>(MarketdateBoothGeoData,
        ['backoffice', 'marketdate-booth-geo-data', marketdayId].join('/'))
        .subscribe((marketdateBoothGeoDataModel: Array<MarketdateBoothGeoData>) => {
          marketdateBoothGeoDataModel.forEach(
            (entry) => {
              this.availableMarketdates.add(entry.mdateEvasiveDate);
              if (reset && (!this.selectedDate || this.selectedDate < entry.mdateEvasiveDate)) {
                this.selectedDate = entry.mdateEvasiveDate;
                console.log('getMarketdateBoothGeoData', this.selectedDate);
              }
            }
          );
          resolve(marketdateBoothGeoDataModel);
        }, error => {
          console.log('error getting marketdateboothgeodata:', error);
          reject();
        });
    });
  }

  mapReady(map: GoogleMap) {
    this.map = map;
    const latLngMiddleGermany = { lat: 51.163361, lng: 10.447683 };
    this.map.setOptions({
      center: latLngMiddleGermany,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      gestureHandling: 'auto',
      zoom: 6
    });

    this.map.addListener('dragend', () => this.agmMap.triggerResize(true).then());
    this.map.addListener('zoom_changed', () => this.agmMap.triggerResize(true).then());

    this.generateMarkers(this.marketdateBoothGeoData);
  }

  generateMarkers(marketdateBoothGeoData: Array<MarketdateBoothGeoData>): void {
    this.marketplaceMarkers = marketdateBoothGeoData.map((m: MarketdateBoothGeoData) => {
      return {
        marketdateBoothGeoData: m,
        marker: new google.maps.Marker({
          title: m.mplaceKeyword,
          position: { lat: parseFloat(m.mplaceLatitude), lng: parseFloat(m.mplaceLongitude)},
          map: this.map,
          icon: './assets/img/market.png'
        }),
        infoWindow: new google.maps.InfoWindow({ content: m.mplaceKeyword})
      };
    });

    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    this.marketplaceMarkers.forEach((marketplaceMarker: CustomMarker) => {
      bounds.extend(marketplaceMarker.marker.position);
      marketplaceMarker.marker.setMap(this.map);
      const marketdays = this.marketplaceDays.get(marketplaceMarker.marketdateBoothGeoData.mplaceId);

      if (marketdays.length > 1) {
        marketplaceMarker.marker.addListener('click', () => {
          this.selectedMarket = this.marketplaceDays.get(marketplaceMarker.marketdateBoothGeoData.mplaceId).sort(
            (a: MarketdateBoothGeoData, b: MarketdateBoothGeoData) => {
              if (a.mdayNumber < b.mdayNumber) {
                return -1;
              }
              if (a.mdayNumber > b.mdayNumber) {
                return 1;
              }
              return 0;
            }
          );
          this.openModal(this.marketDaySelectionModal, {});
        });
      } else {
        marketplaceMarker.marker.addListener('click', () => {
          this.selectMarketDay(marketplaceMarker.marketdateBoothGeoData);
        });
      }

      marketplaceMarker.marker.addListener('mouseover', () => marketplaceMarker.infoWindow.open(this.map, marketplaceMarker.marker));
      marketplaceMarker.marker.addListener('mouseout', () => marketplaceMarker.infoWindow.close());
    });

    this.map.fitBounds(bounds);
  }

  showMarkers(markers: Array<CustomMarker>, fitBounds: boolean): void {
    this.hideAllMarkers();
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    markers.forEach((marker: CustomMarker) => {
      marker.marker.setMap(this.map);
      bounds.extend(marker.marker.position);
    });
    if (fitBounds) {
      this.map.fitBounds(bounds);
    }
  }

  hideAllMarkers(): void {
    this.marketplaceMarkers.concat(this.merchantMarkers).forEach(m => {
      m.infoWindow.close();
      m.marker.setMap(null);
    });
  }

  hideAllMerchantMarkers(): void {
    if (this.merchantMarkers) {
      this.merchantMarkers.forEach(m => {
        m.infoWindow.close();
        m.marker.setMap(null);
      });
    }
  }

  showAllMarketplaceMarkers(): void {
    this.selectedMarket = null;
    this.hideAllMarkers();
    this.showMarkers(this.marketplaceMarkers, true);
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  selectMarketDay(marketdateBoothGeoData: MarketdateBoothGeoData, reset = true) {
    this.selectedMarket = [marketdateBoothGeoData];
    this.selectedMarketDay = marketdateBoothGeoData;

    this.getMarketdateBoothGeoData(marketdateBoothGeoData.mdayId, reset)
      .then((merchantMarketdateBoothGeoData: Array<MarketdateBoothGeoData>) => {
        this.hideAllMerchantMarkers();
        this.merchantMarkers = merchantMarketdateBoothGeoData
          .filter(m => m.mdateEvasiveDate === this.selectedDate)
          .map(m => {
          const infoWindowContent = '<b>' + m.merchantCompany + '</b>'
            + ((m.merchantCompanyAdditional) ? ('<br /> ' + m.merchantCompanyAdditional) : '')
            + ' (' + m.merchantMerchantNumber + ')'
            + '<br />' + m.suIdentification
            + '<br />' + moment(new Date(parseInt(m.geTimestamp, 10))).format('DD.MM.YYYY hh:mm')
            + ( (m.geManual) ? '' : '<br /><em>(Standort Automatisch bestimmt)</em>' );
          const merchantMarker: CustomMarker = {
            marketdateBoothGeoData: m,
            marker: new google.maps.Marker({
              title: infoWindowContent,
              position: { lat: parseFloat(m.geLatitude.toString()), lng: parseFloat(m.geLongitude.toString()) },
              map: this.map
            }),
            infoWindow: new google.maps.InfoWindow({ content: infoWindowContent})
          };
          merchantMarker.marker.addListener('mouseover', () => merchantMarker.infoWindow.open(this.map, merchantMarker.marker));
          merchantMarker.marker.addListener('mouseout', () => merchantMarker.infoWindow.close());
          return merchantMarker;
        });

        const markers = this.merchantMarkers.filter(m => m.marketdateBoothGeoData.mdateEvasiveDate === this.selectedDate).concat(
          this.marketplaceMarkers.filter(m => m.marketdateBoothGeoData.mplaceId === marketdateBoothGeoData.mplaceId)
        );



        this.showMarkers(markers, true);
      });
  }

  changeDate(selectedDate: string) {
    this.selectedDate = selectedDate;
    this.selectMarketDay(this.selectedMarketDay, false);
  }
}



// WEBPACK FOOTER //
// ./src/app/evaluation/components/geographical-data/geographical-data.component.ts